import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "./ui/dialog";
import { LEGAL } from "../mock/mock";

export default function MentionsLegales({ trigger }) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#F4F1EA]">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl text-[#25372D]">
            Mentions légales
          </DialogTitle>
        </DialogHeader>
        <div className="mt-2 space-y-4 text-sm leading-relaxed text-[#3d3a33]">
          <p className="font-medium text-[#25372D]">{LEGAL.editor}</p>
          {LEGAL.paragraphs.map((p) => (
            <p key={p}>{p}</p>
          ))}
          <p>{LEGAL.hosting}</p>
          <p>
            Contact :{" "}
            <a
              href={`mailto:${LEGAL.contactEmail}`}
              className="text-[#25372D] underline"
            >
              {LEGAL.contactEmail}
            </a>
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
